module.exports = __webpack_public_path__ + "img/first-order-alt.7373bf1f.svg";